var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.link}},[_c('div',{staticClass:"card",style:(_vm.cardStyles)},[_c('div',{attrs:{"id":"title"}},[_c('div',{attrs:{"id":"msg"}},[_vm._v(_vm._s(_vm.msg))]),_c('div',{attrs:{"id":"description"}},[_vm._v(_vm._s(_vm.description))])]),_c('img',{attrs:{"id":"icon","src":require('@/assets/images/' + this.icon)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }